export default {
  noAddress: "Keine Adresse",
  title: "Strukturen",
  subtitle: "Alle Plattform-Strukturen",
  searchPlaceholder: "Nach Struktur- oder Eigentümername suchen...",
  loadError: "Strukturen konnten nicht geladen werden",
  retry: "Erneut versuchen",
  empty: "Keine Strukturen entsprechen Ihren Filtern.",
  openRowAria: "Struktur {{name}} öffnen",
  filters: {
    status: "Status",
    statusAll: "Alle",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
  },
  columns: {
    name: "Struktur",
    owner: "Eigentümer",
    commission: "Provision",
  },
} as const;
